type Value = {
	[key: string]: string;
};
type Lng = Record<string, Value>;

const lng: Lng = {
	vi: {
		login: 'Đăng nhập',
		notice: 'Thông báo',
		confirm: 'Xác nhận',
		cancel: 'Huỷ',
		congrats: 'Chúc mừng!',
		defaultError: 'Hiện không thể thực hiện, vui lòng thử lại sau',
		no_account: 'Không thấy thông tin tài khoản',
		not_login: 'Bạn chưa đăng nhập',
		too_many_request: 'Bạn đang thao tác quá nhanh, hãy chậm lại một chút',
		error_time_invalid: 'Thời gian không đúng',
		inactive_user: 'Người chơi không hoạt động',
		error_config: 'Lỗi khởi tạo',
		error_account_not_found: 'Không tìm thấy user',
		error_already_opened: 'Bạn đã mở trước đó',
		error_already_claimed: 'Bạn đã nhận quà rồi',
		error_not_meet_requirement: 'Bạn không đủ yêu cầu',
		error_not_enough: 'Bạn không đủ điều kiện',
		error_no_more: 'Đã nhận hết quà, vui lòng quay lại vào ngày mai',
		error_attack_required: 'Bạn cần phải tấn công trước khi có thể quay tiếp',
		error_friend_locked: 'Bạn của bạn đã bị khoá',
		error_get_friend_top: 'Không có danh sách top bạn bè',
		already_shared:
			'Bạn đã chia sẻ trước đó rồi. Bạn chỉ được chia sẻ 1 lần suốt sự kiện.',
		not_contributed: 'Bạn cần hoàn thành nhiệm vụ đá 1 trận XH/GLXH',
		invalid_code: 'Mã xác nhận không chính xác',
		already_claimed: 'Bạn đã nhập code này rồi',
		already_in_squad: 'HLV bạn vừa kết nạp đã ở trong Tổ Đội khác, vui lòng tìm thành viên mới',
		squad_full: 'Đội của bạn đã đạt đủ số lượng thành viên',
		code_limit_reached: 'Code đã đạt giới hạn tối đa số lần dùng.',
		balance_not_enough: 'Bạn không đủ FC/MC. Vui lòng nạp thêm',
		missing_account_id: 'Bạn vui lòng đăng nhập vào game để tạo HLV.',
		event_ended: 'Sự kiện đã kết thúc.',
		server_error: 'Hiện không thể thực hiện, vui lòng thử lại sau.',
		invalid_edu_email: 'Địa chỉ email không hợp lệ, vui lòng sử dụng email sinh viên để đăng ký',
		invalid_data: 'Dữ liệu không hợp lệ, vui lòng thử lại sau',
		email_mismatch: 'Email xác thực không trùng khớp với email sinh viên đã đăng ký',
		email_registered: 'Email đã được đăng ký rồi.',
		not_enough_money: 'Bạn không FC/MC. Vui lòng nạp thêm',
		email_update_limit_exceeded: 'Rất tiếc, bạn đã dùng hết số lần đổi email cho phép.',
		battle_pass_already_purchased: 'Tháng này bạn đã sở hữu sổ tay rồi, bạn có thể chờ sang tháng sau để tiếp tục mua nếu bạn vẫn còn lượt mua nhé.',
		wait_after_student_confirmed: 'Hệ thống đang xác nhận trạng thái sinh viên của bạn. Vui lòng quay lại sau 24 giờ',
		week_processing: 'Đang tổng hợp dữ liệu tuần, vui lòng thử lại sau',
		monthly_not_registered: 'Bạn cần đăng nhập trước ở trang monthly.fconline.garena.vn rồi quay lại mua sau 5 phút.',
		battle_pass_updating: 'Sổ tay đang cập nhật, vui lòng thử lại sau.',
	},
	en: {
		login: 'Login',
		notice: 'Notice',
		confirm: 'Confirm',
		cancel: 'Cancel',
		congrats: 'Congratulations!',

		defaultError: 'An error has occured, please try again later',
		unauthorized: 'Please login to continue',
		network_error: 'Network error',
		// error_random_choice_fail: '',
		not_auth: 'Please login to continue',
		no_account: 'Please login in to Free Fire with this account',
		invalid_auth: 'Auth error',
		token_expire: 'Token expired',
		not_login: 'You must login to continue',
		too_many_request: 'Too many requests, please wait a minute',
		error_param: 'Invalid params',
		// error_server: 'aaa',
		// error_api: 'aaa',
		// error_invalid_method: 'aaa',
		error_time_invalid: 'Thời gian không đúng',
		inactive_user: 'Người chơi không hoạt động',
		error_config: 'Lỗi khởi tạo',
		error_account_not_found: 'Không tìm thấy user',
		error_already_opened: 'Bạn đã mở trươcs đó',
		error_already_claimed: 'Bạn đã nhận quà rồi',
		error_not_meet_requirement: 'Bạn không đủ yêu cầu',
		error_already_own: 'Bạn đã sở hữu vật phẩm rồi',
		error_locked: 'This has been locked',
		error_no_season: 'Không có season',
		error_not_finished: 'Nhiệm vụ chưa hoàn thành',
		error_already_voted: 'Bạn đã bình chọn rồi',
		error_too_many_vote: 'Bạn đã đạt giới hạn bình chọn',
		error_too_many_invitations: 'Bạn đã đạt giới hạn lời mời',
		error_already_joined: 'Bạn đã gia nhập rồi',
		error_friend_dai_su:
			'Người chơi này đã nằm trong danh sách Đại sứ Free Fire. Bạn thử mời người khác nhé!',
		error_friend_invited: 'Bạn đã mời người bạn này rồi',
		not_contributed: 'Bạn cần hoàn thành nhiệm vụ đá 1 trận XH/GLXH',
	},
};

export default lng;
